import axios from "axios";
import { TowerModel } from "../entities/TowerModel";
import { FloorTowerModel } from "../entities/FloorTowerModel";
import { SubFloorTowerModel } from "../entities/SubFloorTowerModel";

const API_URL = `${process.env.REACT_APP_API_URL}tower`;

export const fetchTower = async (): Promise<TowerModel[]> => {
    const response = await axios.get(API_URL);
    const data = response.data.data; // ["A", "B"]

    // Map string tower names into TowerModel (id = index, name = value)
    return data.map((item: string, index: number) => new TowerModel(index.toString(), item));
};

export const fetchFloor = async (towerId: string): Promise<FloorTowerModel[]> => {
    try {
        const response = await axios.get(`${API_URL}/floor?tower=${towerId}`);
        const data: string[] = response.data.data; // data is array of strings

        // Map strings to FloorTowerModel
        return data.map((floorName: string, index: number) => 
            new FloorTowerModel(
                floorName,
                `Lantai ${floorName}`
            )
        );
    } catch (error) {
        console.error("Error fetching floor:", error);
        throw error;
    }
};

export const fetchSubFloorTower = async (towerId: string, floorId: string): Promise<SubFloorTowerModel[]> => {
    try {
        const response = await axios.get(`${API_URL}/unit?tower=${towerId}&floor=${floorId}`);
        const data = response.data.data; // Ambil array 'data'

        // Map response ke SubFloorTowerModel
        return data.map(
            (item: any) => new SubFloorTowerModel(item.id, item.unit, item.full_address)
        );
    } catch (error) {
        console.error("Error fetching sub floor:", error);
        throw error;
    }
};
